<header class="header">
  <div class="container header-inner">
    <a (click)="navigate('joinus')">
      <img src="assets/logos/newfight/newfight-club-300.png" alt="New Fight Club" class="logo" />
    </a>
    
    <nav class="nav">
      <a [class.active]="s_compass() === 'modalities'" [class.blur]="box_language()" 
         (click)="navigate('modalities')">Modalidades</a>
      <a [class.active]="s_compass() === 'track'" [class.blur]="box_language()"
         (click)="navigate('track')">O Treino</a>
      <a [class.active]="s_compass() === 'agenda'" [class.blur]="box_language()"
         (click)="navigate('agenda')">Agenda</a>
      <a [class.active]="s_compass() === 'packages'" [class.blur]="box_language()"
         (click)="navigate('packages')">Pacotes</a>
      <a [class.active]="s_compass() === 'arena'" [class.blur]="box_language()"
         (click)="navigate('arena')">Nosso Espaço</a>
      
      <a class="highlight" [class.blur]="box_language()" 
        href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, NewFight! Gostaria de saber mais sobre o Performance Club."
        target="_blank">
        <fa-icon [icon]="faWhatsapp" />
        <span>WhatsApp</span>
      </a>

      <!-- <div id="box-language" [class.closed]="!box_language()">
        <div class="bg-glass" [class.blur]="box_language()"></div>
        <a class="trg-close" (click)="navigate('language')">x</a>
        <ul>
          <li>
            <p>EN</p>
          </li>
          <li>
            <app-switch></app-switch>
          </li>
          <li>
            <p>PT</p>
          </li>
        </ul>
      </div> -->
    </nav>

    <a (click)="sidebar('open')" id="trg_sidebar">
        <span id="nav1">_</span><span id="nav2">_</span><span id="nav3">_</span>
    </a>

  </div>
  <!-- <div class="section-divider"></div> -->
</header>